package com.exura.features.plandefinition.data.mappers.plandefinition

import com.exura.features.plandefinition.data.remote.dto.series.*
import com.exura.features.plandefinition.domain.model.element.BasePlanElement
import com.exura.features.plandefinition.domain.model.series.*
import dev.gitlive.firebase.firestore.CollectionReference

/**
 * Base interface for all series mappers.
 * Extends SerializableMappers for Firebase storage compatibility.
 *
 * @param T The specific BaseSeries implementation type
 * @param D The specific BaseSeriesDto implementation type
 */
class PolymorphicSeriesMappers: BaseSeriesMappers<BaseSeries<out BasePlanElement>, BaseSeriesDto> {
    override fun toDto(model: BaseSeries<out BasePlanElement>): BaseSeriesDto = model.toDto()

    override fun toDomain(
        dto: BaseSeriesDto,
        collection: CollectionReference?,
        id: String?
    ): BaseSeries<out BasePlanElement> = dto.toDomain(collection, id)
}
